import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Customers from './pages/Customers';
import Suppliers from './pages/Suppliers';
import Orders from './pages/Orders';
import Invoices from './pages/Invoices';
import Employees from './pages/Employees';
import PurchaseOrders from './pages/PurchaseOrders';
import StockMovements from './pages/StockMovements';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Payroll from './pages/Payroll';
import Settings from './pages/Settings';
import Expenses from './pages/Expenses';
import Accounting from './pages/Accounting';
import Projects from './pages/Projects';
import Tasks from './pages/Tasks';
import TimeLogs from './pages/TimeLogs';
import Leads from './pages/Leads';
import Contacts from './pages/Contacts';
import Opportunities from './pages/Opportunities';
import Activities from './pages/Activities';
import Quotes from './pages/Quotes';
import Assets from './pages/Assets';
import './App.css';

function PrivateLayout({ user, onLogout }) {
  const [pageTitle, setPageTitle] = useState('Dashboard');
  return (
    <div className="layout">
      <Sidebar />
      <div className="main">
        <Header title={pageTitle} user={user} onLogout={onLogout} />
        <Routes>
          <Route path="/" element={<Dashboard setTitle={setPageTitle} />} />
          <Route path="/products" element={<Products setTitle={setPageTitle} />} />
          <Route path="/customers" element={<Customers setTitle={setPageTitle} />} />
          <Route path="/suppliers" element={<Suppliers setTitle={setPageTitle} />} />
          <Route path="/orders" element={<Orders setTitle={setPageTitle} />} />
          <Route path="/invoices" element={<Invoices setTitle={setPageTitle} />} />
          <Route path="/employees" element={<Employees setTitle={setPageTitle} />} />
          <Route path="/purchases" element={<PurchaseOrders setTitle={setPageTitle} />} />
          <Route path="/stock" element={<StockMovements setTitle={setPageTitle} />} />
          <Route path="/reports" element={<Reports setTitle={setPageTitle} />} />
          <Route path="/users" element={<Users setTitle={setPageTitle} />} />
          <Route path="/payroll" element={<Payroll setTitle={setPageTitle} />} />
          <Route path="/settings" element={<Settings setTitle={setPageTitle} />} />
          <Route path="/expenses" element={<Expenses setTitle={setPageTitle} />} />
          <Route path="/accounting" element={<Accounting setTitle={setPageTitle} />} />
          <Route path="/projects" element={<Projects setTitle={setPageTitle} />} />
          <Route path="/tasks" element={<Tasks setTitle={setPageTitle} />} />
          <Route path="/timelogs" element={<TimeLogs setTitle={setPageTitle} />} />
          <Route path="/leads" element={<Leads setTitle={setPageTitle} />} />
          <Route path="/contacts" element={<Contacts setTitle={setPageTitle} />} />
          <Route path="/opportunities" element={<Opportunities setTitle={setPageTitle} />} />
          <Route path="/activities" element={<Activities setTitle={setPageTitle} />} />
          <Route path="/quotes" element={<Quotes setTitle={setPageTitle} />} />
          <Route path="/assets" element={<Assets setTitle={setPageTitle} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('erp_user')); } catch { return null; }
  });
  const handleLogin = (u) => setUser(u);
  const handleLogout = () => {
    localStorage.removeItem('erp_token');
    localStorage.removeItem('erp_user');
    setUser(null);
  };
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />
        <Route path="/*" element={user ? <PrivateLayout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
